'use client';

import Link from 'next/link';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {

  return (
    <div className="min-h-screen bg-brand-black flex flex-col items-center justify-center text-center px-4">
      <div className="w-16 h-16 rounded-2xl bg-brand-red/10 border border-brand-red/20 flex items-center justify-center mx-auto mb-6">
        <AlertTriangle size={28} className="text-brand-red" />
      </div>
      <h1 className="text-3xl font-bold text-brand-white mb-3">Something went wrong</h1>
      <p className="text-brand-gray-light mb-2 max-w-sm">
        An unexpected error occurred. Our team has been notified automatically.
      </p>
      {error.digest && (
        <p className="text-xs text-brand-gray font-mono mb-8">Error ID: {error.digest}</p>
      )}
      <div className="flex items-center gap-3">
        <Button onClick={reset}>
          <RefreshCw size={14} />
          Try again
        </Button>
        <Link href="/">
          <Button variant="ghost">Go Home</Button>
        </Link>
      </div>
    </div>
  );
}
